import { ChoiceQuestion } from "./choice-question";
import type { QuestionTypeRendererProps } from "./shared";

type MultipleAnswerQuestionProps = QuestionTypeRendererProps<"multiple_answer">;

export default function MultipleAnswerQuestionType(props: MultipleAnswerQuestionProps) {
  return <ChoiceQuestion {...props} kind="multiple_answer" />;
}
